/*
 * @创建文件时间: 2020-02-08 16:02:51
 * @最后修改人        : lfq
 * @最后修改时间       : 2020-02-12 13:50:30
 * @联系Qq:1360484677
 * @文件介绍: app后台管理
 */
export default [{
    path: 'sysCarousel',
    name: 'sysCarousel',
    meta: {
        title: 'app轮播管理',
        auth: true
    },
    component: () =>
        import ('@/views/system/appControllers/sysCarousel')
}, {
    path: 'sysAndroidVersion',
    name: 'sysAndroidVersion',
    meta: {
        title: 'app版本信息',
        auth: true
    },
    component: () =>
        import ('@/views/system/appControllers/sysAndroidVersion')
}]